import React, {Component} from 'react';
import PropTypes from 'prop-types';
import SupplierStage1Form from "./SupplierStage1Form";
import SupplierForm from "../SupplierForm";
import {connect} from "react-redux";
import {addSupplier} from "../../../reducers/suppliers/actions";

class SupplierCreate extends Component {
  constructor(props) {
    super(props);

    this.ref = React.createRef()

    this.state = {
      skipStage1: false,
    }
  }

  submit = () => {
    this.ref.current.onSubmit()
  }

  onSaved = supplier => {
    this.props.addSupplier(supplier)
    this.props.onSaved()
  }

  render() {
    if(!this.state.skipStage1 && this.props.supplier.splitStagesAdding){
      return <SupplierStage1Form
        ref={this.ref}
        supplierType={this.props.supplier.value}
        onSkipStage1={() => this.setState({ skipStage1: true, })}
        onSavingStart={this.props.onSubmitStart}
        onSavingStop={this.props.onSubmitStop}
        onSaved={this.onSaved}
      />
    }

    return <SupplierForm
      ref={this.ref}
      submitButton={false}
      supplierSelectHidden
      data={{
        id: null,
        type: this.props.supplier.value
      }}
      onSavingStart={this.props.onSubmitStart}
      onSavingStop={this.props.onSubmitStop}
      onSaved={this.onSaved}
    />
  }
}

SupplierCreate.propTypes = {};

export default connect(null, {addSupplier}, null, {forwardRef: true})(SupplierCreate);